import { biLogger } from '../biLogger';
import { selectBiData } from '../selectors';
import { BiEventLogger } from '../types';

export const logChatbotContactFlowQuickAccessAvailable: BiEventLogger = async (state) => {
  const biData = selectBiData(state);

  biLogger.chatbotContactFlowQuickAccessAvailable({
    conversation_id: biData.conversationId,
  });
};
